import React from 'react';
import { 
  CheckCircleIcon,
  ChatBubbleLeftRightIcon,
  BellIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';

const TelegramSuccessModal = ({ 
  isOpen, 
  onClose 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div 
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal panel */}
        <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full">
          <div className="bg-green-50 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                <CheckCircleIcon className="h-6 w-6 text-green-600" />
              </div>
              <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <h3 className="text-lg leading-6 font-medium text-gray-900">
                  Сервис Telegram успешно инициализирован!
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-600">
                    Теперь система может отправлять уведомления через Telegram ботов.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white px-4 py-5 sm:p-6">
            <div className="space-y-4">
              <h4 className="text-md font-medium text-gray-900 mb-3">
                Что это означает:
              </h4>
              
              <div className="space-y-3">
                <div className="flex items-start">
                  <ChatBubbleLeftRightIcon className="h-5 w-5 text-blue-500 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">Боты подключены</p>
                    <p className="text-sm text-gray-600">Административный и пользовательский боты успешно подключены к Telegram API</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <BellIcon className="h-5 w-5 text-green-500 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">Уведомления активны</p>
                    <p className="text-sm text-gray-600">Система может отправлять уведомления о задачах, отчетах и ошибках</p>
                  </div>
                </div>

                <div className="flex items-start">
                  <DocumentTextIcon className="h-5 w-5 text-purple-500 mt-0.5 mr-3 flex-shrink-0" />
                  <div>
                    <p className="text-sm font-medium text-gray-900">Логирование работает</p>
                    <p className="text-sm text-gray-600">Важные события системы будут отправляться в Telegram для мониторинга</p>
                  </div>
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mt-4">
                <p className="text-sm text-blue-800">
                  <strong>Совет:</strong> Используйте кнопки "Отправить тестовое сообщение" ниже, чтобы проверить работу ботов.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button
              type="button"
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={onClose}
            >
              Понятно
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TelegramSuccessModal; 